import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SessionService } from '../common/session.service';
import * as bootstrap from 'bootstrap';
import { SchoolBillDto,  SchoolBillInfo } from '../api/models';
import { ActivatedRoute } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { HttpErrorResponse } from '@angular/common/http';
import { SchoolBillControllerService } from '../api';


@Component({
  selector: 'app-bill-school',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxPaginationModule
  ],
  templateUrl: './bill-school.component.html',
  styleUrl: './bill-school.component.css'
})
export class BillSchoolComponent  implements OnInit{

 

  @ViewChild('fileBill',{static:false}) fileBill!:ElementRef;


  pageConfig = {itemsPerPage:20, currentPage:0,totalItems:0};
  pageConfigInfo = {itemsPerPage:10, currentPage:0,totalItems:0};
  currPage =1;
  billForm:FormGroup;
  message='';
  messageColor='text-success';
  billInfos?:any;
  bills :Array<SchoolBillDto>=[];
  isLoadFile=false;
  isDetails = false;
  currentSchool=0;
  billType='bill';

  constructor(
    private activeRoute:ActivatedRoute,
    private formBuild:FormBuilder,
    private sessionService:SessionService,
    private billFileService:SchoolBillControllerService
  ){
    

    this.billForm = this.formBuild.group({
      file:[Validators.required],
      status:['',Validators.required],
      idPartner:['',Validators.required]
    });
  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(p=>{
      this.billType =p['billType'];
      console.log(this.billType);
       let sess = this.sessionService.getSessionInfo();
    if(sess.partner?.type=='MERCHANT'){
      this.currentSchool =sess.partner?.id!!;
    this.billForm.controls['idPartner'].setValue(sess.partner?.id!!);
    this.loadBillInfos(0,sess.partner.id!!);
   }
  });
  console.log('reload')
   
  }
  onChangeFile(event:any) {
    
    if(event.target ==null){
      this.billForm.patchValue({ file: null});
    }else {
    const file =event.target.files[0];
    this.billForm.patchValue({ file: file});
    this.billForm.patchValue({status:'OK'});
    }
  
}

  onAddBillFile(){
   
    this.billFileService.loadFile(
      this.billForm.value.file,
      this.billForm.value.idPartner,
      this.billType

    ).subscribe({
      next:()=>{
        console.log('charge ok');
        this.billForm.patchValue({ file: ''});
        this.messageColor ='text-success';
        this.message ='Traitement du fichier en cours. Un mail vous sera envoyé à la fin du traitement';
        this.resetLoadForm();

        const elt =document.getElementById('loadFileResult');
                 const modAdd = new bootstrap.Modal(elt!!);
                 modAdd.show();


      },
      error:(err)=>{
        let resp =JSON.parse(err.error);
        console.log("erss"+resp.message);
        this.message = resp.message;
        this.messageColor ='text-danger';
        this.billForm.patchValue({ file: ''});
        this.resetLoadForm();

        const elt =document.getElementById('loadFileResult');
                 const modAdd = new bootstrap.Modal(elt!!);
                 modAdd.show();
      }
    })

  }
  resetLoadForm(){
    this.fileBill.nativeElement.value='';
  }
loadNextBillPage(page:number){
     console.log(page);
    this.detailsFile(this.billInfos.content[0],page-1,this.pageConfig.itemsPerPage);
  }
  onDetailsFile(billInfo:SchoolBillInfo){
    this.detailsFile(billInfo,0,this.pageConfig.itemsPerPage);
  }

  detailsFile(billInfo:SchoolBillInfo,page:number=0,size:number=20){
    
    this.billFileService.getFilesContent1(
      this.currentSchool,
      billInfo.fileName!!,
      this.billType,
      size,
      page
    ).
    subscribe({
      next:(resp)=>{
        this.bills = resp?.content || [];
        
        this.pageConfig.totalItems = resp?.page?.totalElements || 0;
        this.isLoadFile=false;
        this.isDetails=true;

      },
      error:(err)=>{
        this.message = err.error.message;
        this.messageColor ='text-danger';
        
        const elt =document.getElementById('loadFileResult');
                 const modAdd = new bootstrap.Modal(elt!!);
                 modAdd.show();
      }
    })
  }
  loadBillInfos(page: number, idPartner: number){
    console.log(this.billType);
    this.billFileService.getFilesInfo(
      idPartner,
      page,
      this.pageConfigInfo.itemsPerPage,
      this.billType
    ).subscribe(
      {
        next:(resp)=>{
          this.billInfos = resp;
          if(this.billInfos.content?.length==0){
            this.message = 'Pas de fichier chargé';
             this.messageColor ='text-danger';
        
        const elt =document.getElementById('loadFileResult');
                 const modAdd = new bootstrap.Modal(elt!!);
                 modAdd.show();
            this.isLoadFile = true;
          }else {
            this.pageConfigInfo.currentPage= (resp?.page?.number || 0)+1 ;

            this.pageConfigInfo.totalItems= resp?.page?.totalElements || 0;
            this.isLoadFile=false;
          }
        },
        error:()=>{
          this.isLoadFile =true;
        }
      }
    )
  }
  onLoadFile(){
    this.isLoadFile =!this.isLoadFile;

    if(this.isLoadFile ==false){

      this.loadBillInfos(0,this.currentSchool);
    }else {
      this.isDetails=false;
    }
  }
  onStopPayment(){
    this.billFileService.stop1(
     ).subscribe(
      {
        next:()=>{
          this.message = 'Paiements arrêtés avec succès';
          this.messageColor ='text-success';
           const elt =document.getElementById('loadFileResult');
                 const modAdd = new bootstrap.Modal(elt!!);
                 modAdd.show();
        },
        error:(err:HttpErrorResponse)=>{ 
          this.message = err.error.message;
          this.messageColor ='text-danger';
           const elt =document.getElementById('loadFileResult');
                 const modAdd = new bootstrap.Modal(elt!!);
                 modAdd.show();
        }
  });
  }
  onNextPageFile(page:number){
    console.log('page'+page);
    this.loadBillInfos(page-1, this.currentSchool);

  }
}
